import { render, staticRenderFns } from "./DesignIcon.vue?vue&type=template&id=cd67ffc4&"
import script from "./DesignIcon.vue?vue&type=script&lang=js&"
export * from "./DesignIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports